"use client";
import Loader from "@/components/loader/loader";
import { useLocalsListStore } from "@/zustand/localesList";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import api from "../../../api";
import { getCookie } from "../../../helper/helper";
import Aboutus from "../about-us/page";
import BlackbullNewCollection from "../blackbull-new-collection/page";
import HomePage from "../home/page";
import OctaveCollection from "../octave-collection/page";
import ProductDetails from "../product-details/page";
import Rarestcollection from "../rarest-collection/page";
import ShopNow from "../shop-now/page";
import SingleCask from "../single-cask/page";
import Battlehill from "../battlehill/page";
import OurAwards from "../our-awards/page";
import IndainSummerGinpage from "../indian-summer-gin/page";
import PrivacyPolicy from "../privacy-policy/page";
import Number868Collection from "../number-868/page";
import CreateYourOwn from "../create-your-own/page";
import NewOctaveCollection from "../new-octave-collection/page";
import NewProductDetails from "../new-product-details/page";
import RegistrationForm from "../wholesale/page";

const Master = () => {
  const path = usePathname();
  const [meta, setMeta]: any = useState({});
  const [pageData, setData]: any = useState({});
  const [template, setTemplateName]: any = useState("");
  const [loader, setLoader] = useState(false);
  const localesList = useLocalsListStore((state: any) => state.localesList);
  const locale = localesList.locale || getCookie("locale");

  const fetchPageData = async (props: any) => {
    let locale = getCookie("locale");
    setLoader(true);
    const response: any = await api
      .getPageData(path, locale ? { locale: locale } : {})
      .catch((err: any) => {
        console.log("ERROR: ", err);
        setLoader(false);
      });
    setData(response?.data);

    setMeta(response?.data?.data?.attributes?.seo);
    let template: any = response ? response?.headers["template-name"] : "";
    setTemplateName(template);
    setLoader(false);
    if (!template) {
      getElement();
    }
  };

  useEffect(() => {
    const currentpath = path?.split("/")[1];

    if (currentpath || locale) {
      fetchPageData(currentpath || locale);
    }
  }, [locale, path]);

  const getElement = () => {
    if (loader == false && template) {
      switch (template) {
        case "/":
          return <HomePage data={pageData} meta={meta} />;

        case "template-about-us":
          return <Aboutus data={pageData} meta={meta} />;

        case "rarest-of-the-rare-collection":
          return <Rarestcollection data={pageData} meta={meta} />;

        case "blackbull-collection-page":
          return <BlackbullNewCollection data={pageData} meta={meta} />;

        case "port-ellen-product-detail":
        case "blackbull-product-detail":
        case "ocatave-product-detail":
        case "nickfaldo-totl-product-detail":
        case "indian-summer-gin-product-detail":
        case "special-releases-detail":
        case "single-cask-product-detail":
        case "rarest-of-the-rare-product-detail":
          return <ProductDetails data={pageData} meta={meta} />;

        case "new-octave-collection-product-detail":
          return <NewProductDetails data={pageData} meta={meta} />;

        case "octave-collection":
          return <OctaveCollection data={pageData} meta={meta} />;

        case "new-octave-collection":
          return <NewOctaveCollection data={pageData} meta={meta} />;

        case "create-your-own":
          return <CreateYourOwn data={pageData} meta={meta} />;

        case "single-cask":
          return <SingleCask data={pageData} meta={meta} />;

        case "battlehill":
          return <Battlehill data={pageData} meta={meta} />;

        case "number-868":
          return <Number868Collection data={pageData} meta={meta} />;

        case "our-award":
          return <OurAwards data={pageData} meta={meta} />;

        case "wholesale":
          return <RegistrationForm />;

        case "shop-now":
          return <ShopNow data={pageData} meta={meta} />;

        case "privacy-policy":
          return <PrivacyPolicy data={pageData} meta={meta} />;

        case "indian-summer-gin":
          return <IndainSummerGinpage data={pageData} meta={meta} />;

        default:
          return null;
      }
    } else {
      return <Loader />;
    }
  };

  return getElement();
};

export default Master;
